import { EmbedChannel } from '../channel'
import { ActionButtonReceive, AppParams } from '../interfaces'

export const sendIntegrationParamsOnReady = (
  channel: EmbedChannel,
  params: AppParams,
  authCode: string,
  clientId: string,
) => {
  channel.subscribe('ready', () => {
    const actionButton = params.customization?.checkReport?.actionButton

    channel.send('ancestor', {
      origin: getOrigin(),
    })

    channel.send('integration-params', {
      clientId,
      authCode,
      checkId: params.checkId,
      webappCode: params.webappCode,
      appLanguage: params.appLanguage,
      debug: {
        xundInternal: params.debug?.xundInternal,
        mockReport: params.debug?.mockReport,
      },
      customization: {
        birth: params.customization?.birth,
        gender: params.customization?.gender,
        sex: params.customization?.sex,
        weight: params.customization?.weight,
        height: params.customization?.height,
        age: params.customization?.age,
        riskTopics: params.customization?.riskTopics,
        onboarding: params.customization?.onboarding,
        compactMode: params.customization?.compactMode,
      },
    })
  })
}

const getActionButton = (actionButton?: ActionButtonReceive) => {
  if (actionButton && typeof actionButton === 'object') {
    return {
      ...(actionButton.labelText && { labelText: actionButton.labelText }),
      ...(actionButton.onClick && { onClick: Boolean(actionButton.onClick) }),
    }
  }

  return actionButton
}

const getOrigin = () => {
  const isIframe = document.location.origin === 'null'
  return !isIframe ? document.location.origin : document.location.ancestorOrigins?.[0] ?? '*'
}
